<template>
  <Component :is="typeof $route.meta.layout === 'function' ? $route.meta.layout() : $route.meta.layout">
    <RouterView />
  </Component>
  <AiAssistantWidget v-if="showAiAssistantWidget" />
  <HelpDrawer />
  <PLoading />
  <ConfirmationModal />
  <PTooltip />
</template>

<script setup lang="ts">
import { PLoading } from '@pequity/squirrel';
import { defineAsyncComponent } from 'vue';
import AiAssistantWidget from '@/ai-assistant/components/ai-assistant-widget/ai-assistant-widget.vue';
import { useAiAssistantWidget } from '@/ai-assistant/composables/useAiAssistantWidget';
import ConfirmationModal from '@/components/confirmation-modal/confirmation-modal.vue';
import PTooltip from '@/components/p-tooltip/p-tooltip.vue';
import { useHelpStore } from '@/stores/help';

defineOptions({
  name: 'App',
});

// Data
const helpStore = useHelpStore();
const { showAiAssistantWidget } = useAiAssistantWidget();

// Async components
const HelpDrawer = defineAsyncComponent(async () => {
  helpStore.loading = true;
  const helpDrawer = await import('@/help/components/help-drawer.vue');
  helpStore.loading = false;

  return helpDrawer;
});
</script>
